$(document).ready(function() {
  document.querySelectorAll('.form-voucher-search').forEach(input => {
    let isOpen = false

    input.addEventListener('click', e => {
      if (isOpen) {
        input.closest('.parent-form-voucher-search').classList.remove('search-mode')
        isOpen = false
      } else {
        input.closest('.parent-form-voucher-search').classList.add('search-mode')
        isOpen = true
      }
    })
    input.addEventListener('focusin', e => {
      e.preventDefault()
      e.stopPropagation()
      input.closest('.parent-form-voucher-search').classList.add('search-mode')
      setTimeout(() => {
        isOpen = true
      }, 100)
    })
    // outside click
    document.addEventListener('click', e => {
      if (!input.closest('.parent-form-voucher-search').contains(input.closest('label'))) {
        input.closest('.parent-form-voucher-search').classList.remove('search-mode')
        isOpen = false
      }
    })
  })

  // escape
  document.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.parent-form-voucher-search').forEach(el => {
        el.classList.remove('search-mode')
      })
    }
  })

 if (document.querySelectorAll('input[type=radio][class*=user_voucher_id-]').length > 0) {
   document.querySelectorAll('input[type=radio][class*=user_voucher_id-]').forEach(el => {
     el.addEventListener('change', () => {
       let target = el.classList[el.classList.length - 1]
       if (el.checked) {
         document.querySelectorAll('[id*=user_voucher_id-]').forEach(e => {e.classList.add('d-none')})
         if (document.getElementById(target) != null) {
          document.getElementById(target).classList.remove('d-none')
         }
       } else {
         document.querySelectorAll('[id*=user_voucher_id-]').forEach(e => {e.classList.remove('d-none')})
         if (document.getElementById(target) != null) {
          document.getElementById(target).classList.add('d-none')
         }
       }
     })
   })
 }
})
